import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { ImageWithFallback, Link, LoadingKinds, LoadingPlaceholder, createMenu } from 'modules/UI';

export const { useMenu, Menu } = createMenu();

export const LoggedInAction = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

export const UserName = styled.span`
  font-family: ${tokens.font.family.ifood.body};
  color: ${tokens.colors.primary};
  font-size: ${tokens.fontSizes.s};
  line-height: ${tokens.lineHeights.m};
  max-width: 300px;
  margin-right: ${tokens.space.regular};
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
`;

export const UserAvatar = styled(ImageWithFallback)`
  width: 40px;
  height: 40px;
  border: 1px solid #c4c4c4;
  border-radius: ${tokens.radii.l};
  object-fit: cover;
`;

export const ContainerMenu = styled(Menu)`
  padding: ${tokens.space.regular} 38px;
  border-radius: 0;
  z-index: 1;
`;

export const Item = styled(Link)`
  font-family: ${tokens.font.family.ifood.body};
  font-size: 16px;
  line-height: ${tokens.lineHeights.m};
  color: ${tokens.colors.black};
  margin: ${tokens.space.regular} 0;
`;

export const LoadingContainer = styled.div`
  width: 160px;
  height: 40px;
  align-items: center;
  display: flex;
`;

export const LoadingName = styled(LoadingPlaceholder).attrs({ kind: LoadingKinds.PHASER })`
  width: 103px;
  height: 16px;
  margin-right: ${tokens.space.regular};
`;

export const LoadingIcon = styled(LoadingPlaceholder).attrs({ kind: LoadingKinds.PHASER })`
  width: 40px;
  height: 40px;
  border-radius: ${tokens.radii.l};
`;
